// 2026-02 · Modal admin que embebe la MISMA página DataProgresionNew que la
// clienta ve en su dashboard, impersonándola vía header X-Impersonate-Email.
// Todas las lecturas y escrituras (POST /api/workouts, etc.) van contra la
// cuenta de la clienta: el admin registra datos y ella los ve en su cuenta.
import React, { useEffect, useRef } from 'react';
import DataProgresionNew from '../pages/DataProgresionNew';
import axios from 'axios';
import { X } from 'lucide-react';

export default function AdminDataProgresionModal({ email, open, onClose }) {
  // Interceptor scoped: cuando el modal está abierto, inyectamos el header
  // en TODAS las requests que haga `DataProgresionNew` (y sus hijos). Al
  // cerrar removemos el interceptor para no afectar el resto del admin.
  const interceptorIdRef = useRef(null);

  useEffect(() => {
    if (!open || !email) return;
    const id = axios.interceptors.request.use((config) => {
      // Solo inyectar en requests al backend propio (REACT_APP_BACKEND_URL)
      try {
        if (config?.url && typeof config.url === 'string' && config.url.includes(process.env.REACT_APP_BACKEND_URL)) {
          config.headers = config.headers || {};
          config.headers['X-Impersonate-Email'] = email;
          // El token de la clienta/otra cuenta en localStorage no sirve aquí: siempre el del admin.
          const adminToken = localStorage.getItem('deisycfit_admin_token');
          if (adminToken) {
            if (typeof config.headers.set === 'function') config.headers.set('Authorization', `Bearer ${adminToken}`);
            else config.headers.Authorization = `Bearer ${adminToken}`;
          }
        }
      } catch { /* no-op */ }
      return config;
    });
    interceptorIdRef.current = id;
    return () => {
      if (interceptorIdRef.current !== null) {
        axios.interceptors.request.eject(interceptorIdRef.current);
        interceptorIdRef.current = null;
      }
    };
  }, [open, email]);

  if (!open || !email) return null;

  return (
    <div
      className="fixed inset-0 z-[70] bg-black/80 backdrop-blur-sm overflow-y-auto"
      data-testid="admin-data-progresion-modal"
    >
      <div className="min-h-screen px-2 py-4">
        <div className="max-w-6xl mx-auto bg-gradient-to-b from-gray-950 to-black border border-cyan-500/30 rounded-xl shadow-2xl">
          <div className="relative z-10 rounded-t-xl flex items-center justify-between px-4 py-3 bg-cyan-500/10 border-b border-cyan-500/30 backdrop-blur">
            <div>
              <p className="text-[10px] uppercase tracking-wider text-cyan-200 font-bold">Vista impersonada · Admin</p>
              <p className="text-sm text-white font-semibold">Data Progresión de {email}</p>
              <p className="text-[10px] text-amber-200 italic mt-0.5">
                Lo que registres aquí se guarda en la cuenta de la clienta y ella lo ve igual.
              </p>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-full hover:bg-cyan-500/20 text-cyan-200 hover:text-white transition-colors"
              data-testid="admin-data-progresion-close"
              aria-label="Cerrar"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          {/* Renderizamos la MISMA página user-facing dentro del modal. El
              interceptor de arriba se encarga del header. */}
          <div className="relative">
            <DataProgresionNew embedded />
          </div>
        </div>
      </div>
    </div>
  );
}
